import { useIntegratedForm } from '../use-integrated-form';

export function FormIsLoading(props: { children: React.ReactElement }): React.ReactElement {
    const integratedForm = useIntegratedForm();
    return integratedForm.query.isInitialLoading ? props.children : <></>;
}
